import { render } from "./allGames.vue?vue&type=template&id=d625e828"
import script from "./allGames.vue?vue&type=script&lang=js"
export * from "./allGames.vue?vue&type=script&lang=js"

import "./allGames.vue?vue&type=style&index=0&id=d625e828&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__